import Feature from './Feature';
export default Feature;